module.exports = require('./helpers/bundle-url').getBundleURL('4qPut') + "symbol-defs.9d9fd998.svg";